import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import isNumber from 'lodash/isNumber'
import { theme } from '../../../style'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => (isNumber(width) ? `${width}px` : width)};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-wrap: ${({ justifyContent }) => justifyContent};
  background-color: ${({ bgColor }) => theme[bgColor]};
`

const Column = ({
    width,
    alignItems,
    justifyContent,
    flexWrap,
    bgColor,
    ...rest
}) => (
    <Container
        width={width}
        alignItems={alignItems}
        justifyContent={justifyContent}
        flexWrap={flexWrap}
        bgColor={bgColor}
        {...rest}
    />
)

Column.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    alignItems: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'stretch',
    ]),
    justifyContent: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'space-between',
        'space-around',
        'space-evenly',
    ]),
    flexWrap: PropTypes.oneOf([
        'nowrap',
        'wrap',
        'wrap-reverse',
    ]),
    bgColor: PropTypes.oneOf(Object.keys(theme)),
    // Plus all native div component props
}

Column.defaultProps = {
    width: 'auto',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    bgColor: 'transparent',
}

export default Column
